export enum FeatureOnboardingStatus {
	PENDING = "PENDING",
	SEEN = "SEEN",
	DISMISSED = "DISMISSED",
}

export enum FeatureOnboardingPlacement {
	TOP = "top",
	BOTTOM = "bottom",
	LEFT = "left",
	RIGHT = "right",
}
